type MetaPixel = ((...args: unknown[]) => void) & {
  queue?: unknown[][]
  loaded?: boolean
  version?: string
  callMethod?: (...args: unknown[]) => void
  push?: unknown
}

declare global {
  interface Window {
    fbq?: MetaPixel
    _fbq?: MetaPixel
  }
}

export const META_PIXEL_ID = '1558250596049272'

function ensurePixel(): MetaPixel | undefined {
  if (typeof window === 'undefined') return undefined
  if (window.fbq) return window.fbq

  const fbq: MetaPixel = (...args: unknown[]) => {
    if (fbq.callMethod) {
      fbq.callMethod(...args)
      return
    }
    fbq.queue?.push(args)
  }
  fbq.queue = []
  fbq.loaded = true
  fbq.version = '2.0'
  fbq.push = fbq
  window.fbq = fbq
  window._fbq = fbq

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  return fbq
}

export function initMetaPixel() {
  const fbq = ensurePixel()
  if (!fbq) return

  fbq('init', META_PIXEL_ID)
  fbq('track', 'PageView')
}
